<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Teams" @click="$router.push('/myteam')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <span>
                        <v-switch
                            v-model="viewAll"
                            label="View all"
                            color="primary"
                            hide-details
                        ></v-switch> 
                    </span>
                </v-toolbar>

                <!-- by cutoff -->
                <v-data-table
                   :headers="isMobile?header_mobile:header"
                    :items="attendance_corrections_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync1"
                    v-show="!viewAll"
                >
                    <template v-slot:items="props">
                        <tr @click="viewCutoffDetails(props.item)" style="cursor:pointer;" title="Click to view timesheet for this period">
                            <td v-if="isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                    {{ props.item.cutOffStart | moment("MMM DD") }} - {{ props.item.cutOffEnd | moment("DD, YYYY") }}
                                </span>
                            </td>
                            <td v-if="!isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td v-if="!isMobile">{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            
                <!-- all attendance corrections for selected year -->
                <v-data-table
                    :headers="isMobile?headers_timesheet_all_mobile:headers_timesheet_all"
                    :items="attendance_corrections_all_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync2"
                    v-show="viewAll"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable">
                            <td>
                                <v-chip class="user-chip-container">
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    <b>{{props.item.firstName}} {{props.item.lastName}}</b>
                                </v-chip>
                            </td>
                            <td>
                                <span v-if="isMobile">{{ props.item.transDate | moment('MMM D') }}</span>
                                <span v-else>{{ props.item.transDate | moment('YYYY-MM-DD (ddd)') }}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.clockIn | moment('hh:mm a') }}</td>
                            <td v-if="!isMobile">{{ props.item.clockOut | moment('hh:mm a') }}</td>
                            <td v-if="!isMobile">{{ props.item.totalHours }}</td>
                            <td v-if="!isMobile">{{ props.item.chargeableHours }}</td>                                                
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout> 
</template>

<script>

import attendanceCorrectionsApi from '@/api/attendancecorrection'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import awsS3Helper from '@/helpers/aws-s3'

export default {     
    name: 'AttendanceCorrections',
    metaInfo: {
        title: 'Attendance Corrections',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Attendance Corrections' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        const routeName1 = `${this.$route.name}-table1`
        const routeName2 = `${this.$route.name}-table2`
        const savedSort1 = userPrefs.getSort(routeName1)
        const savedSort2 = userPrefs.getSort(routeName2)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync1: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName1),
                sortBy: savedSort1.sortBy,
                descending: savedSort1.descending,
            },
            paginationSync2: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName2),
                sortBy: savedSort2.sortBy,
                descending: savedSort2.descending,
            },
            viewAll: userPrefs.getViewAllSwitch(this.$route.name),
            selectedFiscalYear: userPrefs.getCalendarYear(this.$route.name),
            search: userPrefs.getSearchKeyword(this.$route.name),
            error: false,
            errorMessage: '',
            loading: false,
            header: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '10%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutOffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutOffEnd', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutOffStatus',  width: '10%', sortable:true},
            ],
            header_mobile: [
                {text: 'Cutoff Period',align: 'left',value: 'cutOffStart', width: '50%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutOffStatus',  width: '50%', sortable:true},
            ],
            headers_timesheet_all: [
                {text: 'Employee',align: 'left', value:'lastName', width:'15%', sortable:true},
                {text: 'Date',align: 'left', value:'transDate', width:'15%', sortable:true},
                {text: 'Clock-In',align: 'left',value: 'clockIn', width:'10%',sortable:true},
                {text: 'Clock-Out',align: 'left',value: 'clockOut', width:'10%',sortable:true},
                {text: 'Total Hours',align: 'left',value: 'totalHours', width:'10%',sortable:true},
                {text: 'Chargeable Hours',align: 'left',value: 'chargeableHours', width:'10%',sortable:true}, 
                {text: 'Status',align: 'left', value:'status', width:'10%',sortable:true},
            ],
            headers_timesheet_all_mobile: [
                {text: 'Employee',align: 'left', value:'lastName', width:'50%', sortable:true},
                {text: 'Date', align: 'left',value: 'transDate', width:'20%', sortable:true},
                {text: 'Status',align: 'left', value:'status', width:'20%', sortable:true},
            ],
            attendance_corrections_summary: [],
            attendance_corrections_all: [],            
            menu_status: false,
        }
    },
    methods: {
        isCurrentPeriod(data){
            return data.cutOffPeriodDesc == 'Current'
        },
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            userPrefs.updateCalendarYear(this.$route.name, fiscalYear)
            this.initialize(false)
        },
        viewCutoffDetails(data) {
            this.$router.push(`/myteam/corrections/${data.cutOffId}`)
        },  
        viewDetails(data) {
            if (this.$store.state.userId == data.userId) {
                this.$router.push(`/myattendance/corrections/details/${data.attendanceCorrectionsId}`)
            }else{
                this.$router.push(`/myteam/corrections/details/${data.attendanceCorrectionsId}`)
            }
        }, 
        async getAttendanceCorrectionsSummary(show_loading) {
            try {
                this.loading = show_loading
                const response = await attendanceCorrectionsApi.getSummaryByTeam()
                if (response && response.status == 200) {
                    this.attendance_corrections_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        async getAllAttendanceCorrections(show_loading) {
            try {
                this.loading = show_loading
                const response = await attendanceCorrectionsApi.getByFYByTeam(this.selectedFiscalYear)
                if (response && response.status == 200) {
                    this.attendance_corrections_all = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        initialize(show_loading) {
            if (this.viewAll) 
                this.getAllAttendanceCorrections(show_loading)
            else
                this.getAttendanceCorrectionsSummary(show_loading)
        }
    },
    created() {
         //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} Attendance Corrections`
        })

        this.initialize(true)
    },
    watch: {
        'paginationSync1.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-table1`, newVal);
        },
        'paginationSync2.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-table2`, newVal);
        },
        'paginationSync1.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table1`, newVal, this.paginationSync1.descending)
        },
        'paginationSync2.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table2`, newVal, this.paginationSync2.descending)
        },
        'paginationSync1.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table1`, this.paginationSync1.sortBy, newVal)
        },
        'paginationSync2.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table2`, this.paginationSync2.sortBy, newVal)
        },
        viewAll(newVal) {
            userPrefs.updateViewAllSwitch(this.$route.name, newVal)
            this.initialize(false)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        attendance_corrections_summary_filtered() {
            var temp = this.attendance_corrections_summary.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            if (this.search) {
                temp = temp.filter(item => {
                    return (item.cutOffStart.includes(this.search) || item.cutOffEnd.includes(this.search))
                })
            }
            return temp //.reverse()
        },
        attendance_corrections_all_filtered() {
            var temp = this.attendance_corrections_all
            
             //search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase()
                temp = temp.filter(item => {
                    const transDateMatch = item.transDate.includes(this.search)
                    const firstNameMatch = item.firstName.toLowerCase().includes(searchLower)
                    const lastNameMatch = item.lastName.toLowerCase().includes(searchLower)
                    return transDateMatch || firstNameMatch || lastNameMatch
                })
            }
            return temp
        },
        helpPageId() {
            return 'attendance-corrections-review-team'
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>